jQuery(document).ready(function($){

	// Accordion
	$('.accordion__heading').click(function(e) {
		e.preventDefault();
		var activeClass = 'accordion__heading--active';
		var $wrapper = $(this).closest('.accordion');

		var $targetElement = $('#' + $(this).data('target'));

		if ($(this).hasClass(activeClass)) {
			$(this).removeClass(activeClass);
			$targetElement.slideUp(200);
		} else {
			$wrapper.find('.accordion__heading').removeClass(activeClass);
			$wrapper.find('.accordion__content').slideUp(200);
			$(this).addClass(activeClass);
			$targetElement.slideDown(200);
		}
	});

});